import React from "react";
import BaseClassOverview from "../../school/routes/ClassesOverview";

const AdminClassOverview = () => {
  return <BaseClassOverview />;
};

export default AdminClassOverview;
